export const hex2bin = (hex) => {
    return ("00000000" + (parseInt(hex, 16)).toString(2)).slice(-8);
}

const isNumber = (value) => {
    return typeof value === 'number' && isFinite(value);
};

const isNumberObject = (n) => {
    return (Object.prototype.toString.apply(n) === '[object Number]');
};

export const isCustomNumber = (n) => {
    return isNumber(n) || isNumberObject(n);
};